import { useMutation, type UseMutationOptions } from "@tanstack/react-query";
import { FromURL } from "../types";
import { getJwt } from "@/features/auth/utils";
import { isAllowedOrigin } from "@/features/utils/domains";

export default function usePartnerChange(
  options?: UseMutationOptions<
    void,
    Error,
    { partner: FromURL; url: string; partnerType?: string; lang?: string }
  >
) {
  return useMutation<
    void,
    Error,
    { partner: FromURL; url: string; partnerType?: string; lang: string }
  >({
    mutationFn: async (data: {
      partner: FromURL;
      url: string;
      partnerType?: string;
      lang: string;
    }) => {
      if (data.partner) {
        if (data.partner === FromURL.None) sessionStorage.removeItem("origin");
      }
      const ifrm = document.createElement("iframe");
      ifrm.style.display = "none";
      ifrm.src = `${data.url}change-partner?lang=${data.lang}&theme=${localStorage.getItem(
        "theme"
      )}`;
      ifrm.id = "iframes-" + data.partner;
      document.body.appendChild(ifrm);
      ifrm.onload = () => {
        setTimeout(() => {
          const email =
            sessionStorage.getItem("username") ??
            JSON.parse(sessionStorage.getItem("user") as string)?.email;
          ifrm?.contentWindow?.postMessage(JSON.stringify({ ...getJwt(), email }), `${data.url}`);
        }, 1000);
      };

      window.addEventListener("message", (message: MessageEvent) => {
        if (!isAllowedOrigin(message.origin)) return;
        if (message.data === "ERROR") {
          window.location.replace("/");
          document.removeChild(ifrm);
        }
        if (message.data === "RECEIVED") {
          sessionStorage.removeItem("jwt");
          window.location.replace(data.url);
          document.removeChild(ifrm);
        }
      });
    },
    ...options
  });
}
